export const state = {
  fromGlobalInsideState: 'fromGlobalInsideState',
}

export const getters = {}

export const actions = {}

export const mutations = {}
